import jwkToPem from 'jwk-to-pem';
import { decode, verify } from 'jsonwebtoken';
import { promisify } from 'util';

import _data from './_data';

const jwtVerify = promisify(verify);

export const isTokenJwt = (token) => {
    const decodedJwt = decode(token, { complete: true });

    if (decodedJwt === null) {
        return false;
    }

    return true;
};

const getPublicKeys = async () => {
    const url = `${Project.cognitoPool || ''}/.well-known/jwks.json`;
    const publicKeys = await _data.get(url);

    return publicKeys.keys.reduce(
        (agg, current) => {
            const pem = jwkToPem(current);
            //@ts-ignore
            agg[current.kid] = { instance: current, pem };
            return agg;
        },
        {}
    );
};

export const TOKEN_VALIDATION_STATE = {
    Invalid: 'invalid',
    Expired: 'expired',
    Valid: 'valid',
};

export const validateCognitoToken = async (token) => {
    // Fail if the token is not jwt
    if (!isTokenJwt(token)) {
        return TOKEN_VALIDATION_STATE.Invalid;
    }

    // Fail if token is not from your UserPool
    const decodedJwt = decode(token, { complete: true });
    const { iss = '' } = decodedJwt.payload;
    if (iss !== Project.cognitoPool) {
        return TOKEN_VALIDATION_STATE.Invalid;
    }

    // Get the kid from the token and retrieve corresponding PEM
    const { kid = '' } = decodedJwt.header;
    const pemMap = await getPublicKeys();
    const { pem } = pemMap[kid];
    if (!pem) {
        return TOKEN_VALIDATION_STATE.Invalid;
    }

    try {
        await jwtVerify(token, pem, { issuer: Project.cognitoPool });
    } catch (err) {
        if (err.name === 'TokenExpiredError') {
            return TOKEN_VALIDATION_STATE.Expired;
        }
        return TOKEN_VALIDATION_STATE.Invalid;
    }

    return TOKEN_VALIDATION_STATE.Valid;
};

export const refreshTokens = async () => {
    const refreshToken = API.getCookie('evolveyou_refresh_token');

    const refreshTokenUrl = `${Project.loginPage}/api/refresh-token`;
    const resp = await _data.get(`${refreshTokenUrl}?token=${refreshToken}`);
    const { id_token: idToken = '', access_token: accessToken = '' } = resp;

    const domain = Project.env === 'dev' ? 'localhost' : '.evolveyou.app';

    if (typeof idToken === 'string') {
        API.setCookie('evolveyou_id_token', idToken, {
            domain,
            secure: true,
            maxAge: 2592000,
            path: '/',
        });
    }

    if (typeof accessToken === 'string') {
        API.setCookie('evolveyou_access_token', accessToken, {
            domain,
            secure: true,
            maxAge: 2592000,
            path: '/',
        });
    }

    return idToken;
};
